import React, { Fragment } from 'react'
import { codamHistoryIntro, codamHistoryTimeline } from '../../../constants/codamHistoryData'

import ThemeMenuThree from '../../../components/header/ThemeMenuThree'
import PageTitle from '../../../components/page-title/PageTitle'
import FooterThree from '../../../components/footer/FooterThree'

const History = () => {
    return (
        <Fragment>
            <div className="main-page-wrapper">
                <ThemeMenuThree />
                <PageTitle title="코담 연혁" />

                <section className="codam-history pt-120 pb-120 pt-lg-70 pb-lg-70">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-xl-10">
                                <div className="section-title-two text-center mb-50">
                                    <h6 className="sub-title mb-20">{codamHistoryIntro.subTitle}</h6>
                                    <h2 className="sect-title">{codamHistoryIntro.title}</h2>
                                    <p className="mt-20 mb-0">{codamHistoryIntro.lede}</p>
                                </div>
                            </div>
                        </div>

                        <div className="row justify-content-center">
                            <div className="col-xl-10">
                                <div className="codam-history__timeline">
                                    {codamHistoryTimeline.map((item) => (
                                        <div key={item.year} className="codam-history__item">
                                            <div className="codam-history__year">{item.year}</div>
                                            <div className="codam-history__content">
                                                <ul className="mb-0">
                                                    {item.events.map((event) => (
                                                        <li key={event}>{event}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <FooterThree hideNewsletter />
            </div>
        </Fragment>
    )
}

export default History
